'use es6';

import { findIndex } from 'underscore';
import { updateFormField } from 'FormsUI/actions/FormDefinition';
import { getFormFieldGroups } from 'FormsUI/selectors/FormDefinition';
import { getObjectTypeIdValue } from 'FormsCommonComponents/form-definition/utils/FormFieldUtils';
import { getIsMultiplePaymentLinks, getLinkGroupIndexByField } from 'FormsUI/utils/PaymentsUtils';
import { moveFormFieldIntoNewFormFieldGroup } from 'FormsUI/actions/FormDragDrop';
import updateFormFieldKey from 'forms-utils-lib/formField/utils/updateFormFieldKey';
import updateDependentFieldKey from 'forms-utils-lib/dependent-fields/updateDependentFieldKey';
import FormFieldKeys from 'forms-utils-lib/constants/formField/FormFieldKeys';
import DependentFieldKeys from 'forms-utils-lib/constants/formField/DependentFieldKeys';
import isField from 'forms-utils-lib/formField/utils/isField';
export const update = newField => (dispatch, getState) => {
  const state = getState();
  const updatedGroups = getFormFieldGroups(state).map(group => {
    const isSmartGroup = group.isSmartGroup || false;
    const fieldInGroupIndex = findIndex(group.fields, currentField => isField(currentField, newField.name, getObjectTypeIdValue(newField.objectTypeId, newField.propertyObjectType)));
    const isNewFieldInGroup = fieldInGroupIndex >= 0;
    const isSmartFieldStatusChanged = isNewFieldInGroup ? newField.isSmartField !== group.fields[fieldInGroupIndex].isSmartField : false;
    const isSmart = isSmartFieldStatusChanged ? newField.isSmartField : isSmartGroup;
    const updatedFields = group.fields.map((field, index) => {
      if (isNewFieldInGroup && fieldInGroupIndex === index) {
        return updateFormFieldKey(newField, FormFieldKeys.IS_SMART_FIELD, isSmart);
      }
      if (isNewFieldInGroup) {
        return updateFormFieldKey(field, FormFieldKeys.IS_SMART_FIELD, isSmart);
      }
      return updateFormFieldKey(field, FormFieldKeys.DEPENDENT_FIELD_FILTERS, field.dependentFieldFilters.map(filter => {
        if (isField(filter.dependentFormField, newField.name, getObjectTypeIdValue(newField.objectTypeId, newField.propertyObjectType))) {
          return updateDependentFieldKey(filter, DependentFieldKeys.DEPENDENT_FORM_FIELD, newField);
        }
        return filter;
      }));
    });
    return Object.assign({}, group, {
      isSmartGroup: isSmart,
      fields: updatedFields
    });
  });
  dispatch(updateFormField(updatedGroups));
};
export const moveFieldToBottom = formField => (dispatch, getState) => {
  const state = getState();
  const formFieldGroups = getFormFieldGroups(state);
  const sourceFormFieldGroupIndex = getLinkGroupIndexByField(formFieldGroups, formField);
  const targetFormFieldGroupIndex = formFieldGroups.length;
  dispatch(moveFormFieldIntoNewFormFieldGroup(sourceFormFieldGroupIndex, formField.name, formField.propertyObjectType, targetFormFieldGroupIndex));
};
export const updatePaymentField = field => dispatch => {
  const isMultiplePaymentLinks = getIsMultiplePaymentLinks(field);
  const updatedPaymentField = updateFormFieldKey(field, FormFieldKeys.HIDDEN, !isMultiplePaymentLinks);
  if (!isMultiplePaymentLinks) {
    dispatch(moveFieldToBottom(updatedPaymentField));
  }
  dispatch(update(updatedPaymentField));
};